<template>
    <div class="autocomplete">
        <input class="form-control autocomplete-input"
               type="text" placeholder="Company"
               name="company_name" autocomplete="off"
               v-model="searchText"
               @keyup="startSearchFrom($event)"
               required
        >
        <input type="hidden" name="company_id" :value="companyId">
        <div  class="autocomplete-result-list" v-if="this.searchData.length !== 0">
            <div class="result" v-for="(data_obj, data_index) in this.searchData" @click="setSearch(data_obj)">
                {{ data_obj.name }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchText: null,
                companyId: null,
                typingTimeout: null,
                searchData: [],
            };
        },

        props: {
            prop_page_search_company_ajax: {
                required: true,
                type: String
            },
        },

        mounted() {
        },

        methods: {
            startSearchFrom(event){
                let _self = this;
                clearTimeout(this.typingTimeout);

                this.typingTimeout = setTimeout(function () {
                    _self.searchFetch(event);
                }, 1000);
            },

            searchFetch(event){
                let _self = this;
                let searchText = event.target.value;
                let page_url = this.prop_page_search_company_ajax.replace('company_name_query_text', searchText);

                if (searchText.length < 3) {
                    _self.searchData = [];
                    return;
                }

                axios.get(page_url, {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    _self.searchData = response.data;
                }).catch(error => {
                    _self.searchData = [];
                }).finally(() => {

                });
            },

            setSearch(obj){
                console.log(obj);
                this.companyId = obj.id;
                this.searchText = obj.name;
                this.searchData = [];
            }
        }
    }
</script>
